import { render } from "./TreasuryTransactions.vue?vue&type=template&id=51aab75a&scoped=true"
import script from "./TreasuryTransactions.vue?vue&type=script&lang=js"
export * from "./TreasuryTransactions.vue?vue&type=script&lang=js"

import "./TreasuryTransactions.vue?vue&type=style&index=0&id=51aab75a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51aab75a"]])

export default __exports__